import { animate, motion, useAnimation } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import { dataSlider } from "../data/dataSlider";
import "react-icons/bi";
import { BiCaretLeft, BiCaretRight, BiLink } from "react-icons/bi";
import { FaRocket } from "react-icons/fa";
import moment from "moment";
const Projects = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
  });
  const diffDays = (date, otherDate) =>
    Math.ceil(Math.abs(date - otherDate) / (1000 * 60 * 60 * 24));

  // Example

  const animation = useAnimation();
  const coffee = useRef(null);
  const cert = useRef(null);
  const proj = useRef(null);
  const [slideIndex, setSlideIndex] = useState(1);
  const nextSlide = () => {
    if (slideIndex !== dataSlider.length) {
      setSlideIndex(slideIndex + 1);
    } else if (slideIndex === dataSlider.length) {
      setSlideIndex(1);
    }
  };

  const prevSlide = () => {
    if (slideIndex !== 1) {
      setSlideIndex(slideIndex - 1);
    } else if (slideIndex === 1) {
      setSlideIndex(dataSlider.length);
    }
  };
  const moveDot = (index) => {
    setSlideIndex(index);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, [10000]);
    return () => clearInterval(interval);
  });
  useEffect(() => {
    if (inView) {
      animation.start({
        scale: 1,
        transition: {
          type: "spring",
          duration: 1,
          bounce: 0.3,
        },
      });
      const controls = animate(
        0,
        diffDays(new Date("2021-6-01"), new Date(moment().format("l"))),
        {
          duration: 3,
          onUpdate(value) {
            coffee.current.textContent = value.toFixed(0);
          },
        }
      );
      const controls1 = animate(0, 3, {
        duration: 1,
        onUpdate(value) {
          cert.current.textContent = value.toFixed(0);
        },
      });
      const controls2 = animate(0, 3, {
        duration: 2,
        onUpdate(value) {
          proj.current.textContent = value.toFixed(0);
        },
      });
      return () => {
        controls.stop();
        controls1.stop();
        controls2.stop();
      };
      //   animation2.start({
      //     scale: 0,
      //   });
    } else {
      cert.current.textContent = 0;
      proj.current.textContent = 0;
      coffee.current.textContent = 0;
      // ref1.textContent = 0;
      animation.start({
        scale: 0,
      });
    }
  }, [inView, animation]);

  return (
    <div ref={ref} className="title-container">
      <motion.h2 animate={animation} className="title">
        Projects
      </motion.h2>
      <div className="project-container">
        <div className="achievements">
          <div className="goal">
            <h1 ref={coffee}>0</h1>
            <p>Cups of Coffee</p>
          </div>
          <div className="goal">
            <h1 ref={cert}>0</h1>
            <p>Certificates</p>
          </div>
          <div className="goal">
            <h1 ref={proj}>0</h1>
            <p>Projects</p>
          </div>
        </div>
        <div className="slide-container">
          {dataSlider.map((data, index) => {
            return (
              <React.Fragment key={data.id}>
                <div
                  className={
                    slideIndex === index + 1 ? "slide active-anim " : "slide"
                  }
                >
                  <div className="image">
                    <img src={data.img} alt={data.img} />
                  </div>

                  <div className="course-container">
                    <h2>{data.type}</h2>
                    <h3>{data.title}</h3>
                    <h3>{data.source}</h3>
                    {data.deployed && (
                      <a href={data.deployed} target="_blank" rel="noreferrer">
                        <FaRocket className="icon" /> Deployed Link
                      </a>
                    )}
                    {data.repo && (
                      <a href={data.repo} target="_blank" rel="noreferrer">
                        <BiLink className="icon" /> Github Repository
                      </a>
                    )}
                  </div>
                </div>
              </React.Fragment>
            );
          })}
          <div className="arrows">
            <BiCaretLeft onClick={() => prevSlide()} className="leftArrow" />
            <BiCaretRight onClick={() => nextSlide()} className="rightArrow" />
          </div>
          <div className="container-dots">
            {Array.from({ length: dataSlider.length }).map((item, index) => (
              <div
                key={index}
                onClick={() => moveDot(index + 1)}
                className={slideIndex === index + 1 ? "dot active" : "dot"}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
